import { createAction, props } from '@ngrx/store';
import { AdressatResource, AufgabeResource } from '@schir-int-client/aufgabe-shared';
import { DownloadedFile } from '@schir-int-client/tech';

const PREFIX = '[Korrespondenz] ';

export const downloadKorrespondenzAction = createAction(
	PREFIX + 'Download Korrespondenz',
	props<{
		adressat: AdressatResource;
	}>()
);

export const downloadKorrespondenzSuccessAction = createAction(
	PREFIX + 'Download Korrespondenz Success',
	props<{
		data: Blob;
	}>()
);

export const downloadKorrespondenzenArchivAction = createAction(
	PREFIX + 'Download Korrespondenzen Archiv',
	props<{
		aufgabe: AufgabeResource;
	}>()
);

export const downloadKorrespondenzenArchivSuccessAction = createAction(
	PREFIX + 'Download Korrespondenzen Archiv Success',
	props<{
		data: DownloadedFile;
	}>()
);

export const downloadKorrespondenzenMergeAction = createAction(
	PREFIX + 'Download Korrespondenzen Merge',
	props<{
		aufgabe: AufgabeResource;
	}>()
);

export const downloadKorrespondenzenMergeSuccessAction = createAction(
	PREFIX + 'Download Korrespondenzen Merge Success',
	props<{
		data: DownloadedFile;
	}>()
);
